import { Fragment, h } from "preact";
import { ButtonPrimary } from '../../../_common/components/buttons/buttons'
import {useLocation, useParams} from 'react-router'
import AlertBox from '../../../_common/components/AlertBox/AlertBox'
import SusceptibleApi from '../../../_api/fct/src/api/SusceptibleApi'

export default function Susceptible () {

  const { id } = useParams()

  function accept() {
    const api = new SusceptibleApi()
    const response = api.apiV1MyaccountSusceptibleContractIdAcceptPostWithHttpInfo(id)
    response.then(function(response_and_data) {
      window.location.href = '/'
    });
  }

  function refuse() {
    const api = new SusceptibleApi()
    const response = api.apiV1MyaccountSusceptibleContractIdRefusePostWithHttpInfo(id)
    response.then(function(response_and_data) {
      window.location.href = '/'
    });
  }

  return (
    <Fragment>
      <AlertBox type='info'>
        <ul className='commitment-list m-l'>
          <p>Ya cumples los requisitos para cursar <span className="font-bold">la FFE (fase de formación en empresa)</span>: tienes más del 30% de las asignaturas superadas y la asignatura de itinerario para la empleabilidad I aprobada.</p>
          <p>Necesitamos saber si tienes <span className="font-bold">intención de cursarlas</span> este próximo curso escolar . Es importante que sepas:</p>
        </ul>

        <ul className='commitment-list m-l'>
          <li style="color: #a90000">Las prácticas tienen <span className="font-bold">2 convocatorias</span> que corren <span className="font-bold">tanto si te presentas como si no</span>.
Es importante que sepas que para <span className="font-bold">finalizar el ciclo formativo, no debes agotarlas</span>.</li>
          <li>Si marcas <span className="font-bold">“sí”</span>, durante este curso escolar podrás realizar tus prácticas. Debes tener en cuenta que deberás realizarlas ya que si no, perderás una convocatoria.</li>
          <li>Si marcas <span className="font-bold">“no”, no te matricularemos, y esa convocatoria no contará</span>. De cara al próximo curso, te volveremos a preguntar si tienes intención de cursarlas 🔜.</li>
        </ul>
      </AlertBox>                  

      <div style="height: 60px;">
        <ButtonPrimary style="float:left;" className='m-top-half' onClick={() => accept()}>SI (INICIAR FFE)</ButtonPrimary>
        <ButtonPrimary style="float:right;" className='m-top-half' onClick={() => refuse()}>NO (NO MATRICULAR)</ButtonPrimary>
      </div>
    </Fragment>
  );
}
